
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";

export const Catalogs: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
            Catalogs
            </Container>
        </React.Fragment>
    );
}